import axiosInstance from "../config/axios.config";

export const partnerOnboardApi = (payload) => {
  return axiosInstance.post("accounts/partner-onboard/", payload);
};
export const getPartnerListApi = (facilityId) => {
  return axiosInstance.get("accounts/list-partners/", {
    params: { facility_id: facilityId },
  });
};

export const updatepartnerOnboardApi = (partner_id, payload) => {
  return axiosInstance.patch(`accounts/update-partner/${partner_id}/`, payload);
};
export const getPartnerOrgsApi = () => {
  return axiosInstance.get(`accounts/fetch-partner-orgs/`);
};
